<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'iban.title' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="ibanBlock"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleNextButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "iban.nextButtonText" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "iban.backButtonText" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="ibanBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #ibanBlock>
  <form [formGroup]="ibanForm">
    <div left-content class="content-container">

      <div class="input-container">
        <app-input
          [label]="'iban.label'"
          [control]="iban"
          [error]="getErrors('iban')"
        ></app-input>
      </div>

      <div class="infobox-container">
        <app-infobox
          [title]="'iban.infobox.title' | translate"
          [content]="'iban.infobox.content' | translate"
        ></app-infobox>
      </div>

    </div>
  </form>
</ng-template>
